/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

export const MANDATE_SEARCH = 'R'
export const MANDATE_EXCLUSIVE_RENTAL_MANAGEMENT = 'GL'
export const MANDATE_SEASONAL_RENTAL = 'LC'
export const MANDATE_SIMPLE_RENTAL = 'LS'
export const MANDATE_EXCLUSIVE_SALE = 'VE'
export const MANDATE_SIMPLE_SALE = 'VS'

export const RentalMandateTypes = [
  MANDATE_EXCLUSIVE_RENTAL_MANAGEMENT,
  MANDATE_SIMPLE_RENTAL
]

export const SaleMandateTypes = [
  MANDATE_EXCLUSIVE_SALE,
  MANDATE_SIMPLE_SALE
]

const MandateTypes = [
  MANDATE_EXCLUSIVE_RENTAL_MANAGEMENT,
  MANDATE_EXCLUSIVE_SALE,
  MANDATE_SEARCH,
  MANDATE_SEASONAL_RENTAL,
  MANDATE_SIMPLE_RENTAL,
  MANDATE_SIMPLE_SALE
]

export default MandateTypes
